import React, { useState, useEffect } from "react";
import instance from "../../instance";
import { Link, useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const NewSupportRequest = () => {
  const [formattedDate, setFormattedDate] = useState("");
  const [supportRequestData, setSupportRequestData] = useState({
    Code: null,
    SystemName: "",
    Governorate: "",
    City: "",
    RequestType: "Technical Support",
    RequestDescription: "",
    Attachments: null,
    IssueDate: new Date(),
    ApprovalStatus: "Pending",
    IDUser: localStorage.getItem("userId") || "", // Get user ID from local storage
    RequestNumber: "",
    Phone: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    // Check if user ID exists in local storage
    const userId = localStorage.getItem("userId");
    if (!userId) {
      toast.error("User not logged in. Please log in first.");
      navigate("/login"); // Redirect to login if no user ID
      return;
    }

    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);

    // Generate a unique request number
    const requestNumber = `OWL-${currentDate.getFullYear()}${(
      currentDate.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}${currentDate
      .getDate()
      .toString()
      .padStart(2, "0")}${Math.floor(Math.random() * 1000)
      .toString()
      .padStart(3, "0")}`;

    setFormattedDate(formattedDate);

    setSupportRequestData((prevData) => ({
      ...prevData,
      IssueDate: currentDate,
      RequestNumber: requestNumber,
      IDUser: userId, // Ensure user ID is set from local storage
    }));
  }, [navigate]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setSupportRequestData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSupportRequestData((prevData) => ({
          ...prevData,
          Attachments: reader.result,
        }));
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleAddSupportRequest = async () => {
    // Validate required fields
    if (
      !supportRequestData.SystemName ||
      !supportRequestData.RequestDescription
    ) {
      toast.error("Please fill in all required fields.");
      return;
    }

    confirmAlert({
      title: "Confirm",
      message: "Are you sure you want to submit this support request?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            try {
              const response = await instance.post(
                "requests",
                supportRequestData
              );

              if (response.status === 201) {
                toast.success(
                  "Support request has been successfully submitted."
                );
                navigate("/support");
              } else {
                toast.error("Error: Support request could not be submitted.");
              }
            } catch (error) {
              console.error("Error:", error);
              toast.error(
                "An error occurred while submitting the support request."
              );
            }
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  return (
    <div>
      <header>
        <h1>New Support Request</h1>
      </header>
      <main>
        <div className="sidebar">
          <Link to="/support" className="sidebar-button">
            ← Main
          </Link>
          {[
            "Information",
            "System Information",
            "Description",
            "Request Details",
          ].map((section) => (
            <button
              key={section}
              onClick={() =>
                scrollToSection(
                  `${section.toLowerCase().replace(/\s+/g, "")}-section`
                )
              }
              className="sidebar-button"
            >
              {section}
            </button>
          ))}
        </div>

        <section id="information-section">
          <h2>Information</h2>
          <ul>
            <li>
              Date:
              <span className="info" id="date">
                {formattedDate}
              </span>
            </li>
            <li>
              Request Number:
              <span className="info" id="requestNumber">
                {supportRequestData.RequestNumber}
              </span>
            </li>

            <li>
              Code:
              <input
                className="input-field"
                type="text"
                id="Code"
                placeholder="Enter Code"
                value={supportRequestData.Code}
                onChange={handleInputChange}
              />
            </li>
          </ul>
        </section>

        <section id="systeminformation-section">
          <h2>System Information</h2>
          <ul>
            <li>
              System Name:
              <input
                className="input-field"
                type="text"
                id="SystemName"
                placeholder="Enter system name"
                value={supportRequestData.SystemName}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Governorate:
              <input
                className="input-field"
                type="text"
                id="Governorate"
                placeholder="Enter governorate"
                value={supportRequestData.Governorate}
                onChange={handleInputChange}
              />
            </li>
            <li>
              City:
              <input
                className="input-field"
                type="text"
                id="City"
                placeholder="Enter city"
                value={supportRequestData.City}
                onChange={handleInputChange}
              />
            </li>
          </ul>
        </section>

        <section id="description-section">
          <h2>Request Description and Attachments</h2>
          <textarea
            className="input-field"
            id="RequestDescription"
            placeholder="Enter detailed request description"
            value={supportRequestData.RequestDescription}
            onChange={handleInputChange}
            rows="10"
          ></textarea>
          <div className="file-upload">
            <input
              type="file"
              id="Attachments"
              onChange={handleFileUpload}
              className="input-field"
            />
            {supportRequestData.Attachments && (
              <span>
                File uploaded: {supportRequestData.Attachments.byteLength} bytes
              </span>
            )}
          </div>
        </section>

        <section id="requestdetails-section">
          <h2>Request Details</h2>
          <ul>
            <li>
              Request Type:
              <select
                className="input-field"
                id="RequestType"
                value={supportRequestData.RequestType}
                onChange={handleInputChange}
              >
                <option value="Technical Support">Technical Support</option>
                <option value="Feature Request">Feature Request</option>
                <option value="Bug Report">Bug Report</option>
                <option value="General Inquiry">General Inquiry</option>
              </select>
            </li>
            <li>
              Issue Date:
              <DatePicker
                selected={supportRequestData.IssueDate}
                onChange={(date) =>
                  setSupportRequestData((prevData) => ({
                    ...prevData,
                    IssueDate: date,
                  }))
                }
                dateFormat="dd/MM/yyyy"
                className="input-field"
              />
            </li>
            <li>
              Phone:
              <input
                className="input-field"
                type="text"
                id="Phone"
                placeholder="Enter phone number"
                value={supportRequestData.Phone}
                onChange={handleInputChange}
              />
            </li>
          </ul>
        </section>

        <button
          className="button3"
          id="addButtonSupportRequest"
          onClick={handleAddSupportRequest}
        >
          Submit Support Request
        </button>
      </main>
    </div>
  );
};

export default NewSupportRequest;
